import {createSignal} from '@pexip/signal';
import type {RoomID, ParticipantID, TransferDetails} from '@pexip/infinity';
import type {
    BreakoutAskingForHelpStatus,
    UserChatMessage,
} from '@pexip/media-components';

import type {MeetingFlow} from '../types';

export const meetingSignal = createSignal({name: 'meeting:meeting'});
export const stepSignal = createSignal<MeetingFlow>({name: 'meeting:step'});
export const remoteStreamSignal = createSignal<MediaStream | undefined>({
    name: 'meeting:remoteStream',
});
export const pinRequiredSignal = createSignal<boolean>({
    name: 'meeting:pinRequired',
});
export const startPresentationSignal = createSignal<{
    stream: MediaStream;
}>({
    name: 'meeting:startPresentation',
});
export const endPresentationSignal = createSignal({
    name: 'meeting:endPresentation',
});
export const presentationStreamSignal = createSignal<MediaStream | undefined>({
    name: 'meeting:presentationStream',
});
export const splashScreenSignal = createSignal({name: 'meeting:splashScreen'});
export const idpSignal = createSignal({name: 'meeting:idp'});
export const layoutOverlayTextEnabledSignal = createSignal({
    name: 'meeting:layoutOverlayTextEnabled',
});
export const infinityErrorSignal = createSignal({
    name: 'meeting:infinityError',
});
export const chatMessageSignal = createSignal<UserChatMessage>({
    name: 'meeting:chatMessages',
});
export const outgoingMessageSignal = createSignal<{
    at: Date;
    id: string;
    message: string;
    direct: boolean;
    recipientId?: ParticipantID;
    recipientDisplayName?: string;
}>({
    name: 'meeting:outgoingMessage',
});
export const chatMessagesSignal = createSignal({name: 'meeting:chatMessages'});
export const unreadChatMessagesSignal = createSignal({
    name: 'meeting:unreadChatMessages',
});
export const directChatMessagesSignal = createSignal({
    name: 'meeting:directChatMessages',
});
export const unreadDirectChatMessagesSignal = createSignal({
    name: 'meeting:unreadDirectChatMessages',
});
export const unseenUnreadDirectChatMessagesSignal = createSignal({
    name: 'meeting:unseenUnreadDirectChatMessages',
});
export const transferSignal = createSignal<TransferDetails>({
    name: 'meeting:transfer',
});
export const liveCaptionsSignal = createSignal({
    name: 'meeting:liveCaptions',
});
export const liveCaptionsEnabledSignal = createSignal({
    name: 'meeting:liveCaptionsEnabled',
});
export const selectedCaptionsLanguageSignal = createSignal({
    name: 'meeting:selectedCaptionsLanguage',
});
export const isTogglingLiveCaptionsSignal = createSignal({
    name: 'meeting:isTogglingLiveCaptions',
});
export const breakoutsAskingForHelpSignal = createSignal<
    BreakoutAskingForHelpStatus[]
>({
    name: 'meeting:breakoutsAskingForHelp',
});
export const breakoutHelpRequestedSignal = createSignal<RoomID>({
    name: 'meeting:breakoutHelpRequested',
});
export const breakoutHelpCancelledSignal = createSignal<RoomID>({
    name: 'meeting:breakoutHelpCancelled',
});
export const guestTransferDetailsSignal = createSignal({
    name: 'meeting:guestTransferDetails',
});
export const hostReferDetailsSignal = createSignal({
    name: 'meeting:hostReferDetails',
});
export const stageParticipantIdsSignal = createSignal<ParticipantID[]>({
    name: 'meeting:stageParticipantIds',
});
export const participantVideoStreamsSignal = createSignal<
    Map<ParticipantID, MediaStream>
>({
    name: 'meeting:participantVideoStreams',
});
export const participantAudioStreamsSignal = createSignal<
    Map<ParticipantID, MediaStream>
>({
    name: 'meeting:participantAudioStreams',
});
export const activeSpeakersSignal = createSignal<Set<ParticipantID>>({
    name: 'meeting:activeSpeakers',
});
